import React, { useContext } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Grid, Link, Checkbox } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { FinanacedOffersSummaryProperty, FinanacedOffersInfoValue } from '../../FolderGeneralDataStyles';
import documentTypeIds from 'constants/documentTypeIds';
import { RightsContext } from 'providers/RightsContext';
import { useSelector, shallowEqual } from "react-redux";

const openFacility = (facilityId, facilitySiteId) => e => {
  e.stopPropagation();
  window.open(`/facilities/${facilityId}/${facilitySiteId}`, "_blank");
};

export const FinancedOffersItemComponentSummary = ({
  clientName,
  offerNumber,
  onChange,
  currentOfferId,
  currentOfferSiteId,
  isSelectionMode,
  selected,
  offerStateName,
  financedAmount,
  currency,
  t,
  offerDate,
  openFinancedOffer,
  offerFinancialProduct,
  offerRezidualPercent,
  offerBaloonPercent,
  offerShowBaloon,
  contractRezidualPercent,
  remainingDuration,
  contractDuration,
  offerAdvancePercent,
  offerDuration,
  offerCellParametrization,
  outstandingAmount,
  documentTypeId,
  uninvoicedAdvance,
  onBlockFacilitySublimitAmountManually,
  hasERPFacility,
  facilityNumber,
  isFacilityBlocked,
  webFacilityId,
  webFacilitySiteId
}) => {
  const isModification = documentTypeId === documentTypeIds.OfferModification;
  const { decisionOfferDrawFromFacility } = useContext(RightsContext);
  const blockFacilitySublimitAmountExecuting = useSelector(state => state.entities?.financedOffers?.[currentOfferId]?.blockFacilitySublimitAmountExecuting || false, shallowEqual);

  return (
    <Grid container spacing={1} whiteSpace='initial'>
      <Grid item xs={12} md={6} lg={3}>
        {isSelectionMode && <Checkbox sx={{ py: 0 }} checked={selected} onChange={onChange} />}
        <FinanacedOffersSummaryProperty>{t('Folder.GeneralData.FinancedOffers.OfferNumber')}</FinanacedOffersSummaryProperty>
        <Link onClick={openFinancedOffer(currentOfferId, currentOfferSiteId)}>
          <FinanacedOffersInfoValue>{offerNumber}</FinanacedOffersInfoValue>
        </Link>
        <FinanacedOffersInfoValue>
          {' / ' + offerStateName + ' / ' + t('DATE_FORMAT', { date: { value: offerDate, format: 'DD.MM.YYYY' } })}
        </FinanacedOffersInfoValue>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <FinanacedOffersSummaryProperty>{t('Folder.GeneralData.FinancedOffers.Client')}</FinanacedOffersSummaryProperty>:{' '}
        <FinanacedOffersInfoValue>{clientName}</FinanacedOffersInfoValue>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.FinancialProduct')}</FinanacedOffersSummaryProperty>:{' '}
        <FinanacedOffersInfoValue>{offerFinancialProduct}</FinanacedOffersInfoValue>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.SeasonalPaymentPlan')}</FinanacedOffersSummaryProperty>
        <Checkbox sx={{ py: 0 }} checked={offerCellParametrization} disabled />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.FinancedAmount')}</FinanacedOffersSummaryProperty>:{' '}
        <FinanacedOffersInfoValue>{`${t('NUMBER', { number: financedAmount })} ${currency}`}</FinanacedOffersInfoValue>
      </Grid>
      {isModification ? (
        <>
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty>
              {' '}
              {t('Folder.GeneralData.FinancedOffers.ContractRezidualPercent')}
            </FinanacedOffersSummaryProperty>
            :{' '}
            <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', {
              number: contractRezidualPercent
            })} %`}</FinanacedOffersInfoValue>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.AdvancePercent')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', { number: offerAdvancePercent })} %`}</FinanacedOffersInfoValue>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.ContractDuration')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('NUMBER', {
              number: contractDuration
            })} ${t('Folder.GeneralData.FinancedOffers.Months')}`}</FinanacedOffersInfoValue>
          </Grid>
        </>
      ) : (
        <>
          {offerShowBaloon ? (
            <Grid item xs={12} md={6} lg={3}>
              <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.BaloonPercent')}</FinanacedOffersSummaryProperty>:{' '}
              <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', { number: offerBaloonPercent })} %`}</FinanacedOffersInfoValue>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} lg={3}>
              <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.RezidualPercent')}</FinanacedOffersSummaryProperty>:{' '}
              <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', {
                number: offerRezidualPercent
              })} %`}</FinanacedOffersInfoValue>
            </Grid>
          )}
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.AdvancePercent')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', { number: offerAdvancePercent })} %`}</FinanacedOffersInfoValue>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.Period')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('NUMBER', { number: offerDuration })} ${t(
              'Folder.GeneralData.FinancedOffers.Months'
            )}`}</FinanacedOffersInfoValue>
          </Grid>
          {hasERPFacility && (
            <Grid item xs={12} md={6} lg={3}>
              <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.Facility.FacilityNumber')}</FinanacedOffersSummaryProperty>{' '}
              <Link onClick={openFacility(webFacilityId, webFacilitySiteId)}>
                <FinanacedOffersInfoValue>{facilityNumber}</FinanacedOffersInfoValue>
              </Link>
              <Button
                color='secondary'
                size='small'
                sx={{ ml: 1 }}
                onClick={(e)=>{
                  onBlockFacilitySublimitAmountManually(currentOfferId, currentOfferSiteId)
                  e.stopPropagation();
                }}
                disabled={
                  !decisionOfferDrawFromFacility ||
                  isFacilityBlocked ||
                  blockFacilitySublimitAmountExecuting
                }
                tooltip={
                  !decisionOfferDrawFromFacility ? t('Folder.GeneralData.FinancedOffers.Facility.UseManuallyUnauthorized') :
                  isFacilityBlocked ? t('Folder.GeneralData.FinancedOffers.Facility.AlreadyBlocked') :
                  blockFacilitySublimitAmountExecuting ? t('Folder.GeneralData.FinancedOffers.Facility.BlockingInProgress') : null
                }
              >
                {t('Folder.GeneralData.FinancedOffers.Facility.UseManually')}
              </Button>
            </Grid>
          )}
        </>
      )}
      {isModification && (
        <>
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.OutstandingAmount')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('NUMBER', { number: outstandingAmount })} ${currency}`}</FinanacedOffersInfoValue>
          </Grid>
          {offerShowBaloon ? (
            <Grid item xs={12} md={6} lg={3}>
              <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.BaloonPercent')}</FinanacedOffersSummaryProperty>:{' '}
              <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', { number: offerBaloonPercent })} %`}</FinanacedOffersInfoValue>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} lg={3}>
              <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.RezidualPercent')}</FinanacedOffersSummaryProperty>:{' '}
              <FinanacedOffersInfoValue>{`${t('PERCENT_NUMBER', {
                number: offerRezidualPercent
              })} %`}</FinanacedOffersInfoValue>
            </Grid>
          )}
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.UninvoicedAdvance')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>
              {`${t('NUMBER', { number: uninvoicedAdvance })} ${currency}`} {' / '}
              {`${t('PERCENT_NUMBER', {
                number: uninvoicedAdvance ? (uninvoicedAdvance * 100) / outstandingAmount : 0
              })} %`}
            </FinanacedOffersInfoValue>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FinanacedOffersSummaryProperty> {t('Folder.GeneralData.FinancedOffers.RemainingDuration')}</FinanacedOffersSummaryProperty>:{' '}
            <FinanacedOffersInfoValue>{`${t('NUMBER', {
              number: remainingDuration || offerDuration
            })} ${t('Folder.GeneralData.FinancedOffers.Months')}`}</FinanacedOffersInfoValue>
          </Grid>
        </>
      )}
    </Grid>
  );
};

FinancedOffersItemComponentSummary.propTypes = {
  clientName: PropTypes.string,
  offerNumber: PropTypes.string.isRequired,
  currentOfferId: PropTypes.number.isRequired,
  currentOfferSiteId: PropTypes.number.isRequired,
  financedAmount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  offerStateName: PropTypes.string.isRequired,
  offerDate: PropTypes.string.isRequired,
  isSelectionMode: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  t: PropTypes.func.isRequired,
  offerFinancialProduct: PropTypes.string,
  offerRezidualPercent: PropTypes.number.isRequired,
  offerBaloonPercent: PropTypes.number,
  offerShowBaloon: PropTypes.bool,
  contractRezidualPercent: PropTypes.number,
  remainingDuration: PropTypes.number,
  contractDuration: PropTypes.number,
  offerAdvancePercent: PropTypes.number.isRequired,
  offerDuration: PropTypes.number.isRequired,
  offerCellParametrization: PropTypes.bool.isRequired,
  outstandingAmount: PropTypes.number,
  documentTypeId: PropTypes.number.isRequired,
  uninvoicedAdvance: PropTypes.number,
  onBlockFacilitySublimitAmountManually: PropTypes.func,
  hasERPFacility: PropTypes.bool,
  facilityNumber: PropTypes.string,
  isFacilityBlocked: PropTypes.bool,
  webFacilityId: PropTypes.number,
  webFacilitySiteId: PropTypes.number
};

export default compose(withTranslation())(FinancedOffersItemComponentSummary);
